import dayjs from 'dayjs';
import { Slot } from '../cleaners/model';
import _ from 'lodash';

export const formatTimeSlots = (time: number) => {
  return `${String(time).padStart(2, '0')}:00`;
};

//NOTE -> valido solo ora che gestiamo slot da 1 ora
export const getSlotHour = (time: number) => {
  const [hour] = String(time).split(':');
  return Number(hour);
};

export const generateTimeSlotsBadges = (
  slots: Slot[],
  selectedSlots: Slot[],
  selectedDay: number,
) => {
  const today = dayjs();
  const selectedDate = dayjs.unix(selectedDay);
  const isSameDay = today.isSame(selectedDate, 'day');
  const currentHour = today.hour();

  const currentSlots = slots
    .map(({ startTime }) => {
      const start = getSlotHour(startTime);
      const end = start + 1;
      return {
        startTime: start,
        endTime: end,
        isSelected: selectedSlots.some(
          (slot) => slot.startTime === start && slot.endTime === end,
        ),
      };
    })
    .filter(({ startTime }) => (isSameDay ? startTime > currentHour : true));

  currentSlots.sort((a, b) => a.startTime - b.endTime);
  return currentSlots;
};
